
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(131|562|60|665)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
